import controller from './advertisement.controller';
import templateT1 from './templates/advertisement-t1.view.html';
import templateAD from './templates/advertisement.adaptative.view.html';

let AdvertisementComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        typeContent: '@',
        positions:'@',
        pageName:'@',
        contentData:'<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if (__env.adaptative) {
  return templateAD;
  } else {
      return templateT1;  
  }
  
  }

export default AdvertisementComponent;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/advertisement/advertisement.component.js
 **/